import { render, staticRenderFns } from "./LimitItem.vue?vue&type=template&id=0d3e23d1&scoped=true"
import script from "./LimitItem.vue?vue&type=script&lang=js"
export * from "./LimitItem.vue?vue&type=script&lang=js"
import style0 from "./LimitItem.vue?vue&type=style&index=0&id=0d3e23d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3e23d1",
  null
  
)

export default component.exports